import React from 'react';

const Alert = () => <h5>Esta aplicación necesita de tu ubicación para funcionar correctamente</h5>;

export default Alert;


// WEBPACK FOOTER //
// ./src/components/Alert.js